module.exports = __webpack_public_path__ + "static/media/image_46.7eed1ce1.png";